import "./CallForProposalsPage.scss";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import {
  HeroWithImage,
  ContentArea,
  GridRow,
  MainIntro,
  GridPresetSidebar,
  GridPresetMainContent,
  MetaInfoBlock,
  ScheduleInfo,
} from "/App.Components";
import { ContentAreaItemMargin } from "../../Shared/ContentAreaItem/ContentAreaItem";
import { CallForProposalsPageProps } from "/Models/Generated/CallForProposalsPageProps";
import { createSpreadableBem } from "/Helpers/createBem";

const CallForProposalsPage = ({
  pageHeader,
  deadline,
  deadlinePrefix,
  deadlinePropertyName,
  mainIntro,
  mainIntroPropertyName,
  mainBody,
  metaInfoBlock,
  sideBar,
  bottomContentArea,
}: CallForProposalsPageProps) => {
  const bem = createSpreadableBem("call-for-proposals-page-norad");
  return (
    <div {...bem("")}>
      {pageHeader && <HeroWithImage {...pageHeader} />}
      {(mainBody || mainIntro || sideBar) && (
        <div {...bem("__main-body")}>
          <GridRow>
            <GridPresetMainContent>
              <div {...bem("__schedule-container")}>
                <ScheduleInfo
                  timeLabel={deadlinePrefix}
                  time={deadline}
                  timePropertyName={deadlinePropertyName}
                />
              </div>
              {(mainIntro || mainIntroPropertyName) && (
                <MainIntro {...{ mainIntro, mainIntroPropertyName }} />
              )}
              {mainBody && (
                <ContentArea
                  {...mainBody}
                  contentAreaType={ContentAreaType.HalfWidth}
                />
              )}
            </GridPresetMainContent>
            <GridPresetSidebar>
              <aside>
                <ContentArea
                  {...sideBar}
                  contentAreaType={ContentAreaType.OneThird}
                  margin={ContentAreaItemMargin.Sidebar}
                />
              </aside>
            </GridPresetSidebar>
          </GridRow>
        </div>
      )}
      {metaInfoBlock && (
        <div {...bem("__meta-info-block-container")}>
          <GridRow>
            <GridPresetMainContent>
              <MetaInfoBlock {...metaInfoBlock} />
            </GridPresetMainContent>
          </GridRow>
        </div>
      )}
      <ContentArea
        {...bottomContentArea}
        contentAreaType={ContentAreaType.FullWidth}
      />
    </div>
  );
};

export default CallForProposalsPage;
